import { render, staticRenderFns } from "./AppCode.vue?vue&type=template&id=04b0b39f&"
import script from "./AppCode.vue?vue&type=script&lang=js&"
export * from "./AppCode.vue?vue&type=script&lang=js&"
import style0 from "./AppCode.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
